<template>
  <div class="saler-item">
    <div class="header">
      <div class="left">
        <span>{{ user.displayName || user.phone || user.userName }}</span>
        <span>{{ user.role }}</span>
        <span>
          <el-popover popper-class="saler-qr">
            <div class="qrcode" :style="{ background: `url(${qrCodeImage}) center no-repeat` }">
              <div v-if="!qrCodeImage"></div>
            </div>
            <div class="actions">
              <el-button type="text" size="mini" @click="doSave">保存二维码</el-button>
              <el-button type="text" size="mini" @click="doCopy">复制链接</el-button>
            </div>
            <i slot="reference" class="crm-icon-qrcode"></i>
          </el-popover>
        </span>
      </div>
      <div v-if="isEdit" class="actions">
        <el-button size="mini" type="text" @click="doSubmit">确认</el-button>
        <el-button size="mini" type="text" @click="doReset">取消</el-button>
      </div>
      <div v-uac="'system.privilegeEdit'" data-uac="system.privilegeEdit$$权限设置.权限编辑" v-else class="actions">
        <el-button size="mini" type="text" @click="isEdit = true">编辑</el-button>
      </div>
    </div>
    <div v-for="grp in permissions" :key="grp.groupName" class="privilege-group">
      <div class="title">{{ grp.groupName }}</div>
      <div class="row">
        <div v-for="pm in grp.options" :key="pm.name" class="col-sm-6">
          <el-checkbox v-model="pm.checked" :disabled="!isEdit">{{ pm.name }}<span v-if="pm.type" class="menu-opt-badge">菜单</span></el-checkbox>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import _ from 'lodash'
import CopyText from '@/libs/copyer'
import download from '@/libs/downloadfile'
import Utils from '@/utils'
import { updateUiPrivilege } from './services'
export default {
  name: 'SalerItem',
  props: {
    user: {
      type: Object,
      default () {
        return {
          id: undefined,
          userName: undefined,
          displayName: undefined,
          phone: undefined,
          proxyCode: undefined,
          role: undefined,
          uiPrivileges: []
        }
      }
    }
  },
  data () {
    return {
      isEdit: false,
      originPrivileges: [],
      qrCodeImage: undefined,
      permissions: []
    }
  },
  computed: {
    proxyUrl () {
      return `http://m.zhaopeiyun.com/m/zpc/register?proxyCode=${this.user.proxyCode}`
    }
  },
  async mounted () {
    this.originPrivileges = [...this.user.uiPrivileges]
    this.qrCodeImage = await Utils.QrCodeImage(this.proxyUrl)
    const data = _.cloneDeep(this.$store.state.permissions)
    data.forEach(grp => {
      grp.options.forEach((opt) => {
        opt.checked = this.user.uiPrivileges.indexOf(opt.code) > -1
      })
    })
    this.permissions = data
  },
  updated () {
    this.originPrivileges = [...this.user.uiPrivileges]
  },
  methods: {
    doReset () {
      this.user.uiPrivileges = [...this.originPrivileges]
      this.isEdit = false
    },
    doSubmit () {
      const destPrivilge = []
      this.permissions.forEach(grp => {
        grp.options.forEach((opt) => {
          if (opt.checked) {
            destPrivilge.push(opt.code)
          }
        })
      })
      updateUiPrivilege(this.user.id, destPrivilge).then(() => {
        this.$message.success('修改成功')
        this.isEdit = false
        this.$emit('privilgeUpdate', destPrivilge)
      })
    },
    doCopy () {
      CopyText(this.proxyUrl).then(() => {
        this.$message.success('已复制到剪贴板')
      })
    },
    doSave () {
      download(this.qrCodeImage, `兆配云-${this.user.displayName}.png`)
    }
  }
}
</script>
